import React, { useState } from "react";
import {
  Drawer,
  List,
  ListItem,
  ListItemText,
  ListItemButton,
  ListItemIcon,
  Divider,
  Box
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import GavelIcon from '@mui/icons-material/Gavel';
import HomeIcon from '@mui/icons-material/Home';
import BlindsClosedOutlinedIcon from '@mui/icons-material/BlindsClosedOutlined';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import PendingActionsOutlinedIcon from '@mui/icons-material/PendingActionsOutlined';
import ListAltOutlinedIcon from '@mui/icons-material/ListAltOutlined';

const Sidebar = ({ open, onClose }) => {
  const navigate = useNavigate();
  const drawerWidth = 240;
  const [activeMenu, setActiveMenu] = useState("/");

  // Colors
  const MutedOrange = "#E67E22";
  const SoftMutedOrange = "#F39C12"; // Lighter tone of Muted Orange for hover
  const SidebarBackground = "#2E3B47"; // A more neutral base color for the background

  const menuList = [
    { name: "Home", url: "/", icon: <HomeIcon style={{ color: MutedOrange }} /> },
    { name: "Case List", url: "/case/list", icon: <ListAltOutlinedIcon style={{ color: MutedOrange }} /> },
    { name: "Pending Case", url: "/case/edit", icon: <PendingActionsOutlinedIcon style={{ color: MutedOrange }} /> },
    { name: "Disposed/ Decreed", url: "/case/disposed-decreed", icon: <BlindsClosedOutlinedIcon style={{ color: MutedOrange }} /> },
    { name: "Users", url: "/users", icon: <PersonOutlineOutlinedIcon style={{ color: MutedOrange }} /> },
    { name: "Courts", url: "/courts", icon: <GavelIcon style={{ color: MutedOrange }} /> },
  ];

  const handleClick = (url) => {
    setActiveMenu(url);  // Update active menu on click
    navigate(url);
    onClose();
  };

  return (
    <Drawer
      anchor="left"
      open={open}
      onClose={onClose}
      sx={{
        width: drawerWidth,
        "& .MuiDrawer-paper": {
          width: drawerWidth,
          backgroundColor: SidebarBackground, // Neutral background for sidebar
        }
      }}
    >
      <List>
        {menuList.map((menu, index) => (
          <Box key={index}>
            <ListItem
              onClick={() => handleClick(menu.url)}
              sx={{
                backgroundColor: activeMenu === menu.url ? MutedOrange : "transparent", // Highlight active menu item with Muted Orange
                borderRadius: 2,
                '&:hover': {
                  backgroundColor: SoftMutedOrange, // Lighter Muted Orange for hover effect
                }
              }}
            >
              <ListItemButton>
                <ListItemIcon sx={{ color: activeMenu === menu.url ? "#fff" : "#BDC3C7" }}>
                  {menu.icon}
                </ListItemIcon>
                <ListItemText
                  primary={menu.name}
                  sx={{
                    color: activeMenu === menu.url ? "#fff" : "#BDC3C7", // White text for active item
                  }}
                />
              </ListItemButton>
            </ListItem>
            <Divider sx={{ borderColor: "#BDC3C7" }} />
          </Box>
        ))}
      </List>
    </Drawer>
  );
};

export default Sidebar;
